import {observable, action,computed} from 'mobx';
import Bunker from '../objects/outputBunker';
import cultureSettings from "../cultureSettings";
import {date} from "../index";

export default class ShipmentStore{

    constructor(){
        this.outputTransport = [];
        // this.addOutputTransport('train','rape',new Date(2019, 6, 10, 0, 0, 0),new Date(2020,10,10),300,3,8)
    }
    @observable lineStatus = 'None';

    @observable shipmentBunker=[
        new Bunker(0,'train'),
        new Bunker(1,'train'),

    ];
    @action findOutputTransport(culture){
        this.outputTransport.find((item)=>item.culture === this.culture)
    }
    @observable outputTransport = []

    @action addOutputTransport(type = 'truck', culture, dateIncome, endDate, amount, wasteLevel, moistureLevel,offerLink){
        let quantity = Math.ceil(amount/((type === 'truck' ? 20 : 60)*cultureSettings[culture].volume));
        this.outputTransport.push(
            {type, culture, dateIncome, endDate, quantity, wasteLevel, moistureLevel,offer:offerLink}
        );
    }

    @action removeOutputTransport(id){
        this.outputTransport.splice(id,1);
    }

    @action filterOutputTransport(){
        if(date) {
            this.outputTransport.filter((item) => (item.endDate < date.day)).forEach((item)=>{
                if(item.offer)item.offer.setStatus('failed')
            });
            this.outputTransport = this.outputTransport.filter((item) => (item.endDate >= date.day))
        }
    }

    @computed get getTotalWheat(){
        return this.outputTransport.reduce((prev, current)=>{return(current.culture === 'wheat' ? current.quantity + prev : prev)},0)
    }
    @computed get getTotalSoy(){
        return this.outputTransport.reduce((prev, current)=>{return(current.culture === 'soy' ? current.quantity + prev : prev)},0)
    }
    @computed get getTotalRape(){
        return this.outputTransport.reduce((prev, current)=>{return(current.culture === 'rape' ? current.quantity + prev : prev)},0)
    }
    @computed get getTotalSunflower(){
        return this.outputTransport.reduce((prev, current)=>{return(current.culture === 'sunflower' ? current.quantity + prev : prev)},0)
    }
    @computed get getTotalCorn(){
        return this.outputTransport.reduce((prev, current)=>{return(current.culture === 'corn' ? current.quantity + prev : prev)},0)
    }


    @computed get getLineStatus(){
        let result = this.shipmentBunker.find((item) => {return item.status === 'clogged';});
        if(result) {return result.status} else{
            result =  this.shipmentBunker.find((item) => item.active);
            if (result)return result.culture;
        }
        return 'None';
    }

}


// WEBPACK FOOTER //
// ./src/shared/stores/GameSessionStore/ShipmentStore.js